import React from 'react'
import { Button } from 'react-bootstrap'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import useWindowSize from '../utils/useWindowSize';
import { Spinner } from 'reactstrap'

interface IBtnProps {
    label: string
    className?: string
    onClick?: () => void
    type?: "button" | "submit" | "reset",
    isLoading: boolean
}

export default function (props: IBtnProps) {

    const [width, _] = useWindowSize()

    return (
        <Button
            className={'btn btn-lg custom-btn ' + props.className} type={props.type ? props.type : "button"} onClick={props.onClick}

            style={{ height: width < 700 ? "2.6rem" : "3.2rem", fontSize: width < 700 ? "16px" : "20.8px" }}>
            {props.isLoading ? <Spinner /> : (props.label)}
            <div className='arrow-btn'><ArrowForwardIcon className='btn-icon' fontSize={width < 700 ? "small" : "medium"} style={{ width: width < 700 ? "1.8rem" : "2.5rem", height: width < 700 ? "1.8rem" : "2.5rem" }} /></div>
        </Button>
    )
}
